import React from 'react';
import moment from 'moment';
import {
  ProspectActivity,
  BlastengineMailCampaignMailBounceProspectActivity,
} from 'api';
import { Link } from 'react-router-dom';
import { MailCampaign } from 'components/Ui/Icon';

interface BlastengineMailCampaignMailBounceActivity extends ProspectActivity {
  resource: BlastengineMailCampaignMailBounceProspectActivity;
}

interface Props {
  prospectActivity: BlastengineMailCampaignMailBounceActivity;
}

export default ({ prospectActivity }: Props) => {
  const {
    resource: {
      mailCampaignSend: { mailCampaign },
    },
  } = prospectActivity;

  return (
    <>
      <MailCampaign />
      <div className="flex-1 ml-2.5">
        <div className="flex items-center min-h-[30px]">
          <h3 className="flex-1 m-0 text-primary font-bold">
            <Link
              target="_blank"
              to={`/mail_campaigns/${mailCampaign.uuid}`}>
              {mailCampaign.title}
            </Link>
          </h3>
          <time className="text-text-2 ml-3.5">
            {moment(prospectActivity.createdAt).format('YYYY/MM/DD HH:mm')}
          </time>
        </div>
        <div className="text-text-2">
          バウンス
        </div>
      </div >
    </>
  );
};
